import { OutlineButton } from "@/components/StoreComponents/StoreButton";
import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";
import { styled } from "@mui/material";

const ClearButton = styled(OutlineButton)({
  width: "auto",
  maxWidth: "200px",
  paddingTop: "9px",
  paddingBottom: "9px",
  paddingLeft: "24px",
  paddingRight: "24px",
  display: "flex",
  justifyContent: "center",
  lineHeight: "1.2",
  alignItems: "center",
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    width: "100%",
    maxWidth: "unset",
    paddingTop: "12px",
    paddingBottom: "12px",
  },
});

export default ClearButton;
